import styles from "./StatusTitle.module.css";

// react
import React from "react";

// tools
import GetStatus from "tools/getStatus";

// Small component to reuse -> Styles depending of status type
// Props -> feature status
export default function StatusTitle(props) {
	const { status } = props;
	const name = GetStatus.getName(status);
	return (
		<div className={[styles["title"], styles["_" + status]].join(" ")}>
			<p>{name}</p>
		</div>
	);
}
